// Fired on window by ltn-toast-service each time a toast opens (a popover in the top layer), so the page-load shutter,
// while it shows, can lift itself back above it
export const TOAST_SHOWN_EVENT = 'ns-toast-shown';
